import Vue from 'vue';
import {
	Form,
	FormItem,
	Input,
	Select,
	Option,
	Button,
	Upload,
	Checkbox,
	Cascader,
	Dialog,
	Message,
	pagination,
	Breadcrumb,
	BreadcrumbItem,
	Carousel,
	CarouselItem,
	Popover,
	MessageBox,
	Badge,
	checkbox,
	checkboxGroup,
	RadioGroup,
  RadioButton,
	Radio
} from 'element-ui';
import '@/assets/scss/theme/element-var.scss';
// import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/css/theme/index.css';

// Vue.use(Loading);
// Vue.use(Progress);
// Vue.use(Switch);
// Vue.use(Pagination);
Message.install = function(Vue) {
	Vue.prototype.$message = Message;
	Vue.prototype.$confirm = MessageBox.confirm;
};

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Cascader);
Vue.use(Dialog);
Vue.use(Message);
Vue.use(pagination);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popover);
Vue.use(Badge);
Vue.use(checkbox);
Vue.use(checkboxGroup);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Radio)
